/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import { SubPage, Copy, Title, CTAs, Button, Form, Grid, GridSet, GridItem, CheckboxField, TextField, SaveButton } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/users/edituser/edituser_styles';



/* ========== ~~~~~~~~~~ ACCOUNT EDIT USER ~~~~~~~~~~ ========== */
class EditUser extends Component {
    constructor(props){
        super(props);
        this.permissions = {
            edit_payment: 'settings.paymentInfo',
            change_permissions: 'settings.users',
            manage_sites: 'settings.sites',
            account_information: 'settings.general',
            adstxt: 'settings.adsTxt',
            create_embeds: 'manageEmbeds',
            home_adMetrics: 'home.adMetrics'
        };
        this.formName = 'editUser';
    }
    componentWillMount(){
        this.props.populateEditUserForm(this.props.userInfo);
    }
    componentWillUnmount() {
        this.props.resetForm(this.formName)
    }
    handleSave = () => {
        this.props.updateUserInformationWithValidation(this.props.fields, this.formFieldData(), this.props.userInfo.userUUID, this.handleSaveSuccess)
    };
    handleSaveSuccess = (e) => {
            this.props.displayModal(false);
            this.props.updateTableWithNewUserInformation(e, this.props.index);
    };
    formFieldData = () =>{
        let formData = {
            firstName: this.props.fields.fname.value,
            lastName: this.props.fields.lname.value,
            email: this.props.fields.email.value,
            phoneNumber: this.props.fields.phone.value,
            permissions: []
        };
        //loop permission fields and push appropriate values in to permissions array
        Object.keys(this.permissions).map(item => this.props.fields[item].value ? formData.permissions.push(this.permissions[item]) : null);
        return formData;
    };
    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSave();
        }
    }
    render() {
        //deconstructing fields object from props
        const {
            fname, lname, email, phone, edit_payment,
            change_permissions, manage_sites,
            account_information, adstxt, create_embeds, home_adMetrics
        } = this.props.fields;
        return(
            <SubPage name={`edituser`} klass={this.props.classes.edituser}>
                <Form name={this.formName} processing={this.props.savingData} handleKeyDown={this.handleKeyDown}>
                    <Copy name={`title`}>
                        <Title size={`medium`}>
                            <h2>Edit User</h2>
                        </Title>
                    </Copy>
                    <Grid direction={`horizontal`} type={`fields`}>
                        <GridSet direction={`vertical`}>
                            <GridItem><TextField type={`text`} name={`fname`} value={fname.value} valid={fname.valid} placeholder={`First Name`} label={`First Name`} formName={this.formName} info={``} required /></GridItem>
                            <GridItem><TextField type={`text`} name={`lname`} value={lname.value} valid={lname.valid} placeholder={`Last Name`} label={`Last Name`} formName={this.formName} info={``} required /></GridItem>
                            <GridItem><TextField type={`text`} name={`email`} value={email.value} valid={email.valid} placeholder={`Email`} label={`Email`} info={``} formName={this.formName} disabled={true} required /></GridItem>
                            <GridItem><TextField type={`tel`} name={`phone`} value={phone.value} valid={phone.valid} placeholder={`Phone`} label={`Phone`} info={``} formName={this.formName} validateOnChange required /></GridItem>
                        </GridSet>
                        <GridSet direction={`vertical`} >
                            <div className={`permissionslabel`}>Permissions</div>
                            <GridItem><CheckboxField type={`checkbox`} name={`edit_payment`} checked={edit_payment.value} value={edit_payment.value} label={`Edit Payment Information`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`change_permissions`} checked={change_permissions.value} value={change_permissions.value} label={`Change user permissions`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`manage_sites`} checked={manage_sites.value} value={manage_sites.value} label={`Manage sites`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`account_information`} checked={account_information.value} value={account_information.value} label={`Edit account information`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`adstxt`} checked={adstxt.value} value={adstxt.value} label={`Manage Ads.txt file`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`create_embeds`} checked={create_embeds.value} value={create_embeds.value} label={`Create, edit, and view embeds`} formName={this.formName} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} name={`home_adMetrics`} checked={home_adMetrics.value} value={home_adMetrics.value} label={`Embed Analytics - Ad Metrics`} formName={this.formName} /></GridItem>
                        </GridSet>
                    </Grid>
                    <CTAs name={`ctas`} >
                        <Button type={`modal`} action={false} variant={`delete`} name={`cancel`} text={`Cancel`} />
                        <SaveButton savingData={this.props.savingData} handleSave={this.handleSave} />
                    </CTAs>
                </Form>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditUser);
